<template>
 <div id="page-container" class="">
  <div class="content-wrap pb-5">
   <PbxDashboard
    v-model:selector="periodSelector"
    :dataSeriesCurrentMonth="dataSeriesCurrentMonth"
    @action="getDataFromElement()"
    @button-selector="(...args) => getSelectedButton(...args)"
    :extensions="extensions"
    :dataSeriesStacked="dataSeriesStacked"
    :urlType="urlType"
    :dataSeriesConcatenated="dataSeriesConcatenated"
    :periodSelector="this.periodSelector"
    @timeSelector="setTimeSelected($event)"
    @all-selected="allSelected($event)"
    :buttonSelected="this.buttonSelected"
    :textMonth="this.textMonth"
    :timeSelected="this.timeSelected"
   />
   <!--  <div v-show="extensions.length === 0">
        <EmptyStateDashboard />
      </div> -->
  </div>
 </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import PbxDashboard from "../../components/PBX/PbxDashboard.vue";
import EmptyStateDashboard from "../../components/PBX/EmptyStateDashboard.vue";

const elementTypes = {
 0: "extension",
 1: "world",
 2: "undefined (2)",
 4: "queue",
 5: "voicemail",
 6: "ivr",
 8: "undefined (8)",
 9: "undefined (9)",
 12: "undefined (12)",
 13: "external_number_no_success",
 14: "call_flow",
 999: "not provided",
};

export default {
 props: ["presentationKey"],
 components: {
  EmptyStateDashboard,
  PbxDashboard,
 },
 data() {
  return {
   elementTypes,
   urlType: "",
   periodSelector: undefined,
   dataSeriesCurrentMonth: [],
   extensions: [],
   dataSeriesStacked: [],
   dataSeriesConcatenated: [],
   timeSelected: [],
   isAllSelected: "",
   buttonSelected: "month",
   textMonth: "",
   data: undefined,
   pbxMap: {},
  };
 },
 methods: {
  allSelected(val) {
   this.isAllSelected = val;
  },
  getSelectedButton(...args) {
   this.buttonSelected = args[0];
   this.textMonth = args[1];
  },
  async getPbxData(key) {
   try {
    const res = await axios.get(
     `https://xp-stats-201.bluerock.tel/api/v1.2/reports/${this.presentationKey}`
    );
    return res.data;
   } catch (error) {
    this.errorHandling(error);
    this.$emit("setLoading", false);
    this.$emit("error404", error.response);
   }
  },
  async getDataFromElement(key) {
   this.$emit("setLoading", true);

   let res = undefined;

   res = await this.getPbxData(key);
   this.pbxMap = res.map ? res.map : null;
   let parameters = res.parameters;
   document.title = parameters?.name;

   this.$store.dispatch("hostName", parameters.host_name);

   this.$store.dispatch("dataSet", parameters.report_type);

   //  this.$store.dispatch("hostTimeZone", parameters.timezone ? parameters.timezone : 0);

   this.urlType = parameters.element_type == 4 ? "queue" : "extension";
   this.periodSelector = this.formatPeriod(parameters.start, parameters.end);

   this.dataSeriesCurrentMonth = [];
   let period = this.formatPeriod(parameters.start, parameters.end);

   let arrayOfElements = [];
   let stringOfElements = parameters.dns;
   this.extensions.length = 0;

   let timeSelected = [];

   if (parameters.time) {
    let splitTime = parameters.time.split(":");
    timeSelected[0] = splitTime[0];
    timeSelected[1] = splitTime[1];
   }

   if (this.dataSet === "originDetails") {
    this.timeSelected = timeSelected;

    arrayOfElements = stringOfElements.split(",");

    let obj = {};
    let objConcat = {};
    let dataObj = {};
    let dataObjSerie = [];

    this.data = res.data;

    this.dataSeriesCurrentMonth = [];
    let keys = [];
    let objectKeyToGet = "";
    let timeSelectedIsHour = false;
    let timeSelectedIsQuarter = false;
    obj["data"] = [];

    if (this.timeSelected.length > 0) {
     if (
      this.timeSelected[0].slice(-2) === "00" &&
      this.timeSelected[1].slice(-2) === "00"
     ) {
      timeSelectedIsHour = true;
     } else {
      timeSelectedIsQuarter = true;
     }
    }

    if (timeSelectedIsHour) {
     keys = Object.keys(res.data.sum_quarter_hourly);
     objectKeyToGet = "sum_quarter_hourly";
    } else if (timeSelectedIsQuarter) {
     keys = Object.keys(res.data.sum_quarter_hourly);
     objectKeyToGet = "sum_quarter_hourly";
    } else {
     keys = Object.keys(res.data.daily);
     objectKeyToGet = "daily";
    }


    if (keys.length > 0) {
     let dataObj = {};
     let dataObjSerie = {};

     const originElements = this.getAllOriginElementsFromKey(keys);

     for (let arrIndex = 0; arrIndex < arrayOfElements.length; arrIndex++) {
      let elementFromArray = arrayOfElements[arrIndex];

      obj = {};
      dataObj = {};

      let elementHasKey = false;

      for (let index = 0; index < keys.length; index++) {
       let splitElement = keys[index].split(":");
       if (splitElement[2] == arrayOfElements[arrIndex]) {
        elementHasKey = true;
       }
      }
      if (elementHasKey) {
       let top10Array = this.getTop10(
        keys,
        objectKeyToGet,
        arrayOfElements[arrIndex],
        res.data,
        originElements
       );

       if (objectKeyToGet === "sum_quarter_hourly") {
        top10Array = this.getTop10QuarterHour(
         keys,
         "all",
         arrayOfElements[arrIndex],
         res.data,
         originElements
        );
       }

       if (objectKeyToGet === "sum_hourly") {
        obj = this.generateDataForHourlyCharts(
         top10Array,
         elementFromArray,
         res.data
        );
       } else if (objectKeyToGet === "sum_quarter_hourly") {
        obj = this.generateDataForHourlyCharts(
         top10Array,
         elementFromArray,
         res.data
        );
       } else if (objectKeyToGet === "daily") {
        obj = this.generateDataForPeriodCharts(
         top10Array,
         elementFromArray,
         res.data
        );
       } else {
        obj = this.generateDataForAllCharts(
         top10Array,
         res.data,
         elementFromArray,
         objectKeyToGet,
         period
        );
       }
      } else {
       dataObjSerie = 0;
       dataObj["No_data"] = { dataObjSerie };
       obj["data"] = dataObj;
       let elementName =
        this.urlType === "queue"
         ? res.map[arrayOfElements[arrIndex]]?.name
         : res.map[arrayOfElements[arrIndex]];
       obj["name"] = arrayOfElements[arrIndex] + " - " + elementName;
      }
      this.dataSeriesCurrentMonth.push(obj);
      this.extensions.splice(arrIndex, 1, obj["name"]);
     }

     this.dataSeriesConcatenated = [];
     objConcat = {};

     let consObjectKeyToGet = objectKeyToGet + "*";
     let top10ArrayCons = this.getTop10(
      keys,
      consObjectKeyToGet,
      "*",
      res.data,
      originElements
     );

     if (objectKeyToGet === "sum_hourly") {
      top10ArrayCons = this.getTop10Hour(
       keys,
       consObjectKeyToGet,
       "*",
       res.data,
       originElements
      );
     } else if (objectKeyToGet === "sum_quarter_hourly") {
      top10ArrayCons = this.getTop10QuarterHour(
       keys,
       "all*",
       "*",
       res.data,
       originElements
      );
     }
     this.generateConsolidatedData(
      top10ArrayCons,
      res.data,
      consObjectKeyToGet,
      period
     );
    } else {
     for (let arrIndex = 0; arrIndex < arrayOfElements.length; arrIndex++) {
      obj = {};
      dataObjSerie = 0;
      dataObj["No_data"] = { dataObjSerie };
      obj["data"] = dataObj;
      let elementName =
       this.urlType === "queue"
        ? res.map[arrayOfElements[arrIndex]]?.name
        : res.map[arrayOfElements[arrIndex]];
      obj["name"] = arrayOfElements[arrIndex] + " - " + elementName;
      this.extensions.splice(arrIndex, 1, obj["name"]);
      this.dataSeriesCurrentMonth.push(obj);
     }
     this.dataSeriesConcatenated = [];
     obj = {};
     dataObjSerie = 0;
     dataObj["No_data"] = { dataObjSerie };
     obj["data"] = dataObj;
     obj["name"] = "cons";
     this.dataSeriesConcatenated.push(obj);
    }
   }
   this.$emit("setLoading", false);
  },
  getTop10(keys, objectKeyToGet, element, data, originElements) {
   let array = [];
   let obj = {};
   let dataObj = {};
   let elementValue = 0;

   for (let index = 0; index < originElements.length; index++) {
    elementValue = 0;
    const originElement = originElements[index];
    for (var el in data[objectKeyToGet]) {
     let splitEl = el.split(":");
     if (splitEl[2] == element) {
      if (splitEl[4] === originElement) {
       let name = undefined;
       if (
        this.pbxMap &&
        (this.elementTypes[splitEl[3]] === "queue" ||
         this.elementTypes[splitEl[3]] === "extension")
       ) {
        if (this.elementTypes[splitEl[3]] === "extension") {
         name = this.pbxMap["extensions"][originElement];
        } else {
         name = this.pbxMap["call_queues"][originElement]["name"];
        }
       }
       elementValue = elementValue + parseInt(data[objectKeyToGet][el]);
       dataObj[
        `${this.elementTypes[splitEl[3]]}-${splitEl[4]}${
         name ? "-" + name : ""
        }`
       ] = elementValue;
       obj["data"] = dataObj;
      }
     }
    }
   }

   if (obj && obj.data && Object.keys(obj.data)) {
    Object.keys(obj.data).forEach(el => {
     array.push([el, obj.data[el]]);
    });

    array.sort(function(a, b) {
     return b[1] - a[1];
    });
   }

   array = array.slice(0, 10);

   return array;
  },
  getTop10QuarterHour(keys, objectKeyToGet, element, data, originElements) {
   let array = [];
   let obj = {};
   let dataObj = {};
   let elementValue = 0;
   let firsQuarterHour =
    (
     "0" +
     (parseInt(this.timeSelected[0].slice(0, 2)) + parseInt(this.hostTimeZone))
    ).slice(-2) + this.timeSelected[0].slice(-2);
   let lastQuarterHour =
    (
     "0" +
     (parseInt(this.timeSelected[1].slice(0, 2)) + parseInt(this.hostTimeZone))
    ).slice(-2) + this.timeSelected[1].slice(-2);

   for (let index = 0; index < originElements.length; index++) {
    elementValue = 0;
    const originElement = originElements[index];
    for (var el in data[objectKeyToGet]) {
     let splitEl = el.split(":");
     if (splitEl[2] == element && splitEl[0].length == 12) {
      let quarterHourlyElementSlice = splitEl[0].slice(-4);
      if (splitEl[4] === originElement) {
       if (
        parseInt(firsQuarterHour) <= parseInt(quarterHourlyElementSlice) &&
        parseInt(quarterHourlyElementSlice) < parseInt(lastQuarterHour)
       ) {
        elementValue = elementValue + parseInt(data[objectKeyToGet][el]);
        dataObj[
         `${this.elementTypes[splitEl[3]]}-${splitEl[4]}`
        ] = elementValue;
       }
       obj["data"] = dataObj;
      }
     }
    }
   }

   if (obj && obj.data && Object.keys(obj.data)) {
    Object.keys(obj.data).forEach(el => {
     array.push([el, obj.data[el]]);
    });

    array.sort(function(a, b) {
     return b[1] - a[1];
    });
   }

   array = array.slice(0, 10);

   return array;
  },
  generateDataForHourlyCharts(arr, elementFromArray, data) {
   let obj = {};
   let dataObj = {};
   let dataObjSerie = {};
   let elementName =
    this.urlType === "queue"
     ? data.map[elementFromArray]?.name
     : data.map[elementFromArray];
   //  let elementName = data.map[elementFromArray];
   obj["name"] = elementFromArray + " - " + elementName;
   for (let index = 0; index < arr.length; index++) {
    const element = arr[index];
    dataObjSerie = element[1];
    dataObj[element[0]] = { dataObjSerie };
    obj["data"] = dataObj;
   }
   return obj;
  },
  generateDataForPeriodCharts(arr, elementFromArray, data) {
   let obj = {};
   let dataObj = {};
   let dataObjSerie = {};
   let elementName =
    this.urlType === "queue"
     ? data.map[elementFromArray]?.name
     : data.map[elementFromArray];
   //  let elementName = data.map[elementFromArray];
   obj["name"] = elementFromArray + " - " + elementName;
   for (let index = 0; index < arr.length; index++) {
    const element = arr[index];
    dataObjSerie = element[1];
    dataObj[element[0]] = { dataObjSerie };
    obj["data"] = dataObj;
   }
   return obj;
  },
  generateDataForAllCharts(
   keys,
   res,
   elementFromArray,
   objectKeyToGet,
   period
  ) {
   let obj = {};
   let dataObj = {};
   let dataObjSerie = {};
   keys.forEach((element, index) => {
    let splitElement = element[0].split(":");
    let label = splitElement[3] + "-" + splitElement[4];
    let elementName = "";
    elementName =
     this.urlType === "queue"
      ? data.map[elementFromArray]?.name
      : data.map[elementFromArray];
    // elementName = res.map[splitElement[1]];
    if (splitElement[2] === period) {
     if (splitElement[1] == elementFromArray) {
      obj["name"] = splitElement[1] + " - " + elementName;
      dataObjSerie = res[objectKeyToGet][element[0]];
      dataObj[label] = {
       dataObjSerie,
      };
      obj["data"] = dataObj;
     }
    }
   });
   return obj;
  },
  generateConsolidatedData(keys, res, objectKeyToGet, period) {
   this.dataSeriesConcatenated = [];
   let objConcat = {};
   let elementFromArray = "*";
   if (objectKeyToGet === "sum_hourly*") {
    objConcat = this.generateDataForHourlyCharts(keys, elementFromArray, res);
   } else if (objectKeyToGet === "sum_quarter_hourly*") {
    objConcat = this.generateDataForHourlyCharts(keys, elementFromArray, res);
   } else if (objectKeyToGet === "daily*") {
    objConcat = this.generateDataForPeriodCharts(keys, elementFromArray, res);
   } else {
    objConcat = this.generateDataForAllCharts(
     keys,
     res,
     elementFromArray,
     objectKeyToGet,
     period
    );
   }
   this.dataSeriesConcatenated.push(objConcat);
  },
  getAllOriginElementsFromKey(keys) {
   let arrayOfElements = [];
   keys.forEach((element, index) => {
    let splitEl = element.split(":");
    arrayOfElements.push(splitEl[4]);
   });
   arrayOfElements = [...new Set(arrayOfElements)];
   return arrayOfElements;
  },
 },
 mounted() {
  this.getDataFromElement(this.presentationKey);
 },
 computed: {
  ...mapGetters([
   "account",
   "pbxElements",
   "pbxTimeSelected",
   "hostName",
   "hostTimeZone",
   "dataSet",
  ]),
 },
 watch: {},
};
</script>

<style>
#page-container {
 position: relative;
 min-height: 97%;
}
#content-wrap {
 padding-bottom: 2rem; /* Footer height */
}
#footer {
 position: absolute;
 bottom: 0;
 width: 100%;
 height: 2.5rem; /* Footer height */
}
</style>
